import { useOrganization } from 'hooks';

export default function useCalendarTimeSlots() {
  const organization = useOrganization();

  function getTimeSlots() {
    if (organization.timeRoundingInterval) {
      const intervalInMinutes = organization.timeRoundingInterval / 60;
      const desiredSlots = 60 / intervalInMinutes;
      // It gets much harder to drag on a 1080p monitor with over 5 timeslots
      if (desiredSlots > 5) {
        // Use 30 minute intervals
        return desiredSlots / 2;
      } else {
        return desiredSlots;
      }
    } else {
      // matches default 15
      return 4;
    }
  }

  const steps = organization.timeRoundingInterval ? organization.timeRoundingInterval / 60 : 15;

  return { timeSlots: getTimeSlots(), steps };
}
